// extracted by mini-css-extract-plugin
module.exports = {"link":"TermsAndConditions_link__7WAmN"};